import React from "react"

import "./routes-loader.component.scss";

const RoutesLoader = () => {
    return (
        <div className="page_loader">
            <div className="darkgrey_strip">
            </div>
            <div className="lightgrey_strip">
            </div>
        </div>
    );
};

export default RoutesLoader